var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherhouses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2983_5544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2983_5544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15.75V8.71875L1.65 9.75L0.75 8.55L9 2.25L17.25 8.55L16.35 9.73125L15 8.71875V15.75H3ZM6 11.25C5.7875 11.25 5.60938 11.1781 5.46562 11.0344C5.32188 10.8906 5.25 10.7125 5.25 10.5C5.25 10.2875 5.32188 10.1094 5.46562 9.96563C5.60938 9.82188 5.7875 9.75 6 9.75C6.2125 9.75 6.39062 9.82188 6.53438 9.96563C6.67812 10.1094 6.75 10.2875 6.75 10.5C6.75 10.7125 6.67812 10.8906 6.53438 11.0344C6.39062 11.1781 6.2125 11.25 6 11.25ZM9 11.25C8.7875 11.25 8.60938 11.1781 8.46563 11.0344C8.32188 10.8906 8.25 10.7125 8.25 10.5C8.25 10.2875 8.32188 10.1094 8.46563 9.96563C8.60938 9.82188 8.7875 9.75 9 9.75C9.2125 9.75 9.39062 9.82188 9.53438 9.96563C9.67813 10.1094 9.75 10.2875 9.75 10.5C9.75 10.7125 9.67813 10.8906 9.53438 11.0344C9.39062 11.1781 9.2125 11.25 9 11.25ZM12 11.25C11.7875 11.25 11.6094 11.1781 11.4656 11.0344C11.3219 10.8906 11.25 10.7125 11.25 10.5C11.25 10.2875 11.3219 10.1094 11.4656 9.96563C11.6094 9.82188 11.7875 9.75 12 9.75C12.2125 9.75 12.3906 9.82188 12.5344 9.96563C12.6781 10.1094 12.75 10.2875 12.75 10.5C12.75 10.7125 12.6781 10.8906 12.5344 11.0344C12.3906 11.1781 12.2125 11.25 12 11.25Z",
    fill: "#898989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherhouses);
export default __webpack_public_path__ + "static/media/otherhouses.45b2a1b465745d800bd3bc5933b4fab0.svg";
export { ForwardRef as ReactComponent };